import React from 'react'
import { TransactableCoin } from '../../transactional-context/interface'

type Props = {
  coin: TransactableCoin
}

/**
 * React component
 * Shows individual coin details for the transaction from the user's input into this coin
 */
const CoinDetails: React.FC<Props> = () => {
  //coin
  // const { icon, dollarValue, name, symbol, outputAmount } = coin
  return <div>CoinDetails</div>
}

export default CoinDetails
